// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const LogoIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  viewBox: "0 0 16 17",
  "aria-hidden": "true",
  "data-icon": "Logo/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 .346a4 4 0 0 0-4 4v4.75h5.562l.413-1.38H4.5l.226-1.02h1.495l.63-2.15h1.288l-.63 2.15h1.929l.63-2.15h1.298l-.63 2.15H16v-2.35a4 4 0 0 0-4-4H4Zm12 7.37h-5.51l-.413 1.38H11.6l-.234 1.02H9.83l-.59 2.03H7.943l.6-2.03H6.625l-.61 2.03H4.726l.6-2.03H0v2.23a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-4.63Zm-8.726 0-.404 1.38H8.79l.403-1.38H7.274Z",
  clipRule: "evenodd"
}));
export default LogoIcon;
